import Vue from 'vue';
import store from '@/store';
import API from './api';


export default {
  /* eslint-disable no-shadow */
  install(Vue, options) {
    const { baseURL } = options;
    /* eslint-disable no-multi-assign */

    Vue.prototype.$api = Vue.api = API.createApi({ baseURL, store });
    this.addInterceptors();
  },

  addInterceptors() {
    Vue.api.axios.interceptors.request.use((config) => {
      const { language, sessionId } = store.state.api;
      const { data } = config;

      config.data = {
        ...data,
        language,
        session_id: sessionId,
      };
      return config;
    }, (error) => {
      Promise.reject(error);
    });
  },
};
